// Local translations
export const T = {
  en_GB: {
    welcome: "Welcome",
    signInToAccount: "Sign in to your account",
  },
  nb_NO: {
    welcome: "Velkommen",
    signInToAccount: "Logg inn på kontoen din",
  },
} as const;
